"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _styledComponents.default.dl.withConfig({
  displayName: "KeyValueList",
  componentId: "design-system__ephupv-0"
})(["border:1px solid #e5e5e5;background-color:rgb(255,255,255);box-shadow:rgba(0,0,0,0.1) 0px 0px 5px;border-color:rgb(235,235,235) rgb(235,235,235) rgb(235,235,235);border-width:1px 1px 1px;border-style:none solid solid;border-image:initial;border-top:none;box-sizing:border-box;padding:2rem 1.5rem;& > div{display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid ", ";height:2.5rem;}& > div:last-child{border-bottom:none;}& > div > dt,& > div > dd{font-size:", ";font-weight:", ";line-height:", ";color:", ";display:flex;align-items:center;}& > div > dt{font-family:", ";display:flex;align-items:center;}& div.term-icon{margin:0.5rem 0.5rem 0.5rem 0;}& > div > dd{font-family:", ";}"], _BaseTheme.default.colors.bluegray, _BaseTheme.default.type.size.small, _BaseTheme.default.type.weight.regular, _BaseTheme.default.type.lineHeight.extra, _BaseTheme.default.colors.textgray, _BaseTheme.default.type.family.system, _BaseTheme.default.type.family.content);

exports.default = _default;